import React from "react";
import { PageTitle } from "../PageTitle";
import { ScrollModule } from "../ScrollModule";
import ScrollArea from "react-scrollbar";
import { Link } from "react-router-dom";

const APIList = () => (
    <div>
        <div className="row">
            <PageTitle title="API Configuration" />
        </div>

        <div className="op-content-box">
            <ScrollModule />
            <ScrollArea speed={0.8} className="scroll-container" contentClassName="scrollable-content" horizontal={true}>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card-block">
                          <Link to="/admin/api/tokens">Manage API Keys</Link>
                        </div>
                    </div>
                </div>
            </ScrollArea>
        </div>
    </div>
);

export default APIList;